import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { WaitlistProvider } from "@/context/WaitlistContext";
import { initLenis } from "@/lib/scroll";
import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";

function App() {
  useEffect(() => initLenis(), []);
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <WaitlistProvider>
          <Routes>
            <Route path="/privacy" element={<Legal page="privacy" />} />
            <Route path="/terms" element={<Legal page="terms" />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </WaitlistProvider>
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
